import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { Modal } from "@replo/design-system/components/modal/Modal";

interface DesignLibraryNavigationBlockerModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  title?: string;
  description?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonVariant?: "destructive" | "primary";
}

export const DesignLibraryNavigationBlockerModal: React.FC<
  DesignLibraryNavigationBlockerModalProps
> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  onCancel,
  title = "Discard changes?",
  description = "You have unsaved Design Library changes. If you leave now, your edits will be lost.",
  cancelButtonText = "Cancel",
  confirmButtonText = "Discard",
  confirmButtonVariant = "destructive",
}) => {
  return (
    <Modal
      open={isOpen}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      footer={
        <div className="flex gap-3 justify-end">
          <Button size="base" variant="secondary" onClick={onCancel}>
            {cancelButtonText}
          </Button>
          <Button
            size="base"
            variant={confirmButtonVariant}
            onClick={() => void onConfirm()}
          >
            {confirmButtonText}
          </Button>
        </div>
      }
      dismissable={false}
    />
  );
};
